<template>
  <div
    class="position-absolute container-fluid after border-top py-2 profile-menu w-menu bg-white rounded-bottom poppins-regular"
    :style="navHeight"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["navHeight"],
}
</script>

<style lang="scss">
.w-menu {
  width: 80vw !important;
  @media only screen and (min-width: 768px) {
    width: 25%;
    max-width: 300px;
  }
}
</style>
